import { createContext, useEffect, useState } from "react";
import useConfig from "../hooks/useConfig";

const SessionContext = createContext({
  session: null,
  sessionReady: false,
});

const SessionProvider = ({ children }) => {
  const config = useConfig();
  const [session, setSession] = useState(null);
  const [sessionReady, setSessionReady] = useState(false);

  useEffect(() => {
    if (!config?.sessionKey) return;

    const sessionKey = config.sessionKey;

    // Initial session check (first time load)
    const initialSession = localStorage.getItem(sessionKey);
    if (initialSession) {
      setSession(initialSession);
      setSessionReady(true);
    } else {
      const waitForInitialSession = () => {
        const check = () => {
          const found = localStorage.getItem(sessionKey);
          if (found) {
            setSession(found);
            setSessionReady(true);
          } else {
            setTimeout(check, 100);
          }
        };
        check();
      };
      waitForInitialSession();
    }

    // Listen to session removal (e.g., logout from another tab)
    const handleStorageChange = (e) => {
      if (e.key === sessionKey) {
        const newValue = e.newValue;
        setSession(newValue);
        setSessionReady(!!newValue);
      }
    };

    window.addEventListener("storage", handleStorageChange);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, [config?.sessionKey]);

  return (
    <SessionContext.Provider value={{ session, sessionReady }}>
      {children}
    </SessionContext.Provider>
  );
};

export { SessionContext, SessionProvider };
